import React from 'react';

// Decorative photo behind a page hero. The parent needs `relative isolate overflow-hidden`.
export const HeroPhoto = ({ src }) => (
  <>
    <img
      src={src}
      alt=""
      aria-hidden="true"
      decoding="async"
      className="absolute inset-0 -z-10 h-full w-full object-cover opacity-60"
    />
    <div className="absolute inset-0 -z-10 bg-slate-950/60" aria-hidden="true" />
  </>
);
